import { useCallback, useState } from 'react';
/**
 * Хук для управления состоянием dropdown меню
 * Гарантирует, что одновременно открыт только один dropdown
 *
 * @param menuKeys - Массив ключей для всех dropdown меню
 * @returns Объект с состоянием и методами управления
 */
export const useDropdown = (menuKeys) => {
    const [openMenu, setOpenMenu] = useState(null);
    /**
     * Закрывает все dropdown меню
     */
    const closeAll = useCallback(() => {
        setOpenMenu(null);
    }, []);
    /**
     * Переключает состояние конкретного dropdown меню
     * Если меню уже открыто - закрывает его
     * Если закрыто - закрывает все остальные и открывает это
     *
     * @param menuKey - Ключ меню для переключения
     */
    const toggle = useCallback((menuKey) => {
        if (openMenu === menuKey) {
            setOpenMenu(null);
        }
        else {
            setOpenMenu(menuKey);
        }
    }, [openMenu]);
    /**
     * Проверяет, открыто ли конкретное меню
     *
     * @param menuKey - Ключ меню для проверки
     * @returns true, если меню открыто
     */
    const isOpen = useCallback((menuKey) => {
        return openMenu === menuKey;
    }, [openMenu]);
    return {
        openMenu,
        closeAll,
        toggle,
        isOpen,
    };
};
